export default "__VITE_ASSET__Cw222$7P__"